import { BaseDynamicFormElement } from '@ebeihilfe/forms';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'ebeihilfe-confirmation-step',
    templateUrl: './confirmation-step.component.html',
    styleUrls: ['./confirmation-step.component.scss'],
    standalone: false
})
export class ConfirmationStepComponent {
  public confirmationForm = new FormGroup({});
  @Input() public fields: BaseDynamicFormElement<any>[];
  @Output() public goBackEmitter = new EventEmitter<void>();
  public model: Record<string, unknown>;
  @Output() public submitEmitter = new EventEmitter<FormGroup>();

  public goBack(): void {
    this.goBackEmitter.emit();
  }

  public submitForm(): void {
    this.submitEmitter.emit(this.confirmationForm);
  }

  public updateModel(model: Record<string, unknown>): void {
    this.model = model;
  }
}
